import { ESortFilter } from '../types/redux/filters';
import { ETabs } from '../types/redux/tabs';

export const sorts = [
  {
    value: ESortFilter.Any,
    label: 'По умолчанию',
  },
  {
    value: ESortFilter.Age,
    label: 'По времени на Циан',
  },
  {
    value: ESortFilter.Name,
    label: 'По алфавиту',
  },
  {
    value: ESortFilter.OffersCount,
    label: 'По количеству объявлений',
  },
];

export const tabs = [
  {
    value: ETabs.Realtors,
    title: 'Риелторы',
  },
  {
    value: ETabs.Agencies,
    title: 'Агентства',
  },
];
